export default __webpack_public_path__ + "static/media/cont12.a4522e19.jpeg";